// import '../Scss/Frontend/Elements/BannerDatenschutz.scss';

;(function($){
    // Set cookie by name, value and expiration in days
    var setCookie = (name, value = true, days = 365) => {
        var t = new Date();
        t.setTime(t.getTime() + 1000*60*60*24*days);
        t = t.toUTCString();
        document.cookie = name + '=' + value + '; expires=' + t + '; path=/;';
    }

    // Get cookie by cookie name
    var getCookie = (name) => {
        let ccName = name + '=';
        let ccArray = document.cookie.split(';');

        let ccValue = ccArray
            .map(el => el.trim())
            .filter(el => el.indexOf(ccName) == 0)
            .toString()
            .slice(ccName.length);

        return ccValue;
    }

    // Check if cookie exists
    var cookieExists = () => 
        getCookie('cookieconsent_dismissed') != '' ? true : false;

    // Accept cookies
    $('.cc-accept').on('click', () => {
        setCookie('cookieconsent_dismissed', 'yes');
        $('.BannerDatenschutz').remove();
    })

    // Show banner on window load
    $(window).on('load', () => {
        if (cookieExists()) $('.BannerDatenschutz').remove();
        else $('.BannerDatenschutz').addClass('show');
    })

})(jQuery);
